<script>
import { useAlert } from 'dashboard/composables';
import ReportFilters from './components/ReportFilters.vue';
import DetailedConversationFinishedTable from './components/DetailedConversationFinishedTable.vue';
import { generateFileName } from '../../../../helper/downloadHelper';
import ReportHeader from './components/ReportHeader.vue';

export default {
  name: 'ConversationFinishedReports',
  components: {
    ReportFilters,
    DetailedConversationFinishedTable,
    ReportHeader,
  },
  data() {
    return {
      from: 0,
      to: 0,
      isLoading: false,
      detailedData: [],
      selectedInbox: null,
    };
  },
  computed: {
    requestPayload() {
      const payload = {
        since: this.from,
        until: this.to,
      };

      if (this.selectedInbox) {
        payload.inbox_id = this.selectedInbox.id;
      }

      return payload;
    },
  },
  methods: {
    async getDetailed() {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch(
          'conversationFinishedReports/getDetailed',
          this.requestPayload
        );
        this.detailedData = response || [];
      } catch {
        useAlert(this.$t('CONVERSATION_FINISHED_REPORTS.FETCH_FAILED'));
      } finally {
        this.isLoading = false;
      }
    },
    async downloadDetailedReports() {
      try {
        await this.$store.dispatch(
          'conversationFinishedReports/downloadDetailedReport',
          {
            fileName: generateFileName({
              type: 'conversation-finished',
              to: this.to,
            }),
            ...this.requestPayload,
          }
        );
      } catch {
        useAlert(this.$t('CONVERSATION_FINISHED_REPORTS.DOWNLOAD_FAILED'));
      }
    },
    onFilterChange({ from, to, inboxes }) {
      this.from = from;
      this.to = to;
      this.selectedInbox = inboxes ? { id: inboxes.id } : null;
      this.getDetailed();
    },
  },
};
</script>

<template>
  <div>
    <div class="mt-4 mb-4">
      <h2 class="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-4">
        {{ $t('CONVERSATION_FINISHED_REPORTS.FILTERS') }}
      </h2>
      <ReportFilters
        filter-type="inboxes"
        :show-group-by="false"
        :show-business-hours="false"
        show-entity-filter
        disable-entity-routing
        @filter-change="onFilterChange"
      />
    </div>

    <ReportHeader :header-title="$t('CONVERSATION_FINISHED_REPORTS.HEADER')">
      <button
        class="button nice"
        :disabled="isLoading || !detailedData.length"
        @click="downloadDetailedReports"
      >
        {{ $t('CONVERSATION_FINISHED_REPORTS.DOWNLOAD') }}
      </button>
    </ReportHeader>

    <div class="flex flex-col gap-4">
      <DetailedConversationFinishedTable
        v-if="from && to"
        :data="detailedData"
        :is-loading="isLoading"
      />

      <div v-else class="flex items-center justify-center p-8">
        <p class="text-slate-600 dark:text-slate-400">
          {{ $t('CONVERSATION_FINISHED_REPORTS.SELECT_PERIOD') }}
        </p>
      </div>
    </div>
  </div>
</template>
